import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-content">
      <div>
        <h1 className="text-[20px] md:text-[24px] !mb-2 md:mb-0">About Owision</h1>
      </div>
      <div>
        <p className="text-[12px] md:text-[16px]">
          We're Stockholm's tech powerhouse merging AI, elite talent, and client obsession to
          transform ideas into market-leading solutions. Startups to enterprises, we deliver
          innovation that outperforms. Let's engineer your future.{" "}
        </p>
      </div>
    </div>
  );
};

export default About;
